import(/* webpackMode: "eager" */ "/vercel/path0/src/app/politicas/precursores-quimicos/page.tsx");
